/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2023 Karmabunny
 */
import { Attraction, FoodDrink } from "../types";
import { API } from "./base";


const api = new API();


/**
 * Hits the `#[Route('{uid}/attractions')]` in the Explore controller in
 * TheyStay/API returning a list of external park attractions
 */
export async function getAttractions(entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/explore/${entity_uid}/attractions`,
    })

    return res.items as Attraction[];
}


/**
 * Hits the `#[Route('{entity_uid}/attractions/{attraction_uid}')]` in the Explore controller in
 * TheyStay/API returning a single attraction
 */
export async function getAttraction(attraction_uid: string, entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/explore/${entity_uid}/attractions/${attraction_uid}`,
    })

    return res as Attraction;
}


/**
 * Hits the `#[Route('{uid}/food-drink')]` in the Explore controller in
 * TheyStay/API returning a list of food-drink
 */
export async function getFoodDrinks(entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/explore/${entity_uid}/food-drink`,
    })

    return res.items as FoodDrink[];
}


/**
 * Hits the `#[Route('{entity_uid}/food-drink/{food_drink_uid}')]` in the Explore controller in
 * TheyStay/API returning a single food-drink
 */
export async function getFoodDrink(food_drink_uid: string, entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/explore/${entity_uid}/food-drink/${food_drink_uid}`,
    })

    return res as FoodDrink;
}
